import { IGioCongDongHoatDongSelectRequest } from "../models/request/gio-cong-dong/IGioCongDongHoatDongSelectRequest";
import { IGioCongDongHoatDongAddOrEdit } from "../models/response/gio-cong-dong/IGioCongDongHoatDongAddOrEdit";
import { apiClient } from "./apiClient";

export const gioCongDongHoatDongApi = {
    load: (request: IGioCongDongHoatDongSelectRequest) => apiClient.get(`gio-cong-dong/hoat-dong?nam_hoc=${request.nam_hoc}&sis_gio_cong_dong_id=${request.gioCongDongId ?? 0}`),
    save: (payload: IGioCongDongHoatDongAddOrEdit) => apiClient.post(`gio-cong-dong/hoat-dong`, payload),
    delete: (id: number) => apiClient.delete(`gio-cong-dong/hoat-dong/${id}`),
    loadDetail: (id: number) => apiClient.get(`gio-cong-dong/hoat-dong/${id}`),
}